import { render } from "./MyRead.vue?vue&type=template&id=72d34cea&scoped=true"
import script from "./MyRead.vue?vue&type=script&lang=js"
export * from "./MyRead.vue?vue&type=script&lang=js"

import "./MyRead.vue?vue&type=style&index=0&id=72d34cea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d34cea"]])

export default __exports__